<template>
  <TagSelector
    :multiple="multiple"
    :items="users"
    :value="value"
    @input="$emit('input', $event)"
    itemText="display_name"
    itemValue="id"
  />
</template>

<script>
export default {
  props: {
    value: [String, Number, Array],
    multiple: Boolean,
    roles: Array,
    badges: Array,
    fromProduction: Boolean,
    fromStaging: Boolean,
    from: Boolean,
  },
  data() {
    return {
      users: [],
    };
  },
  created() {
    this.setUsers();
  },
  methods: {
    async setUsers() {
      const params = this.roles ? { roles: this.roles } : {};
      if (this.badges) params.badges = this.badges;
      if (this.fromProduction) params.from_production = true;
      if (this.fromStaging) params.from_staging = true;
      const { data } = await this.$api.User.lite(params);
      this.users = data;
    },
  },
};
</script>

<style></style>
